/**
* @author ktao 2017-04-07
* 公共参照组件 -- 参照对话框  (单树)
*
*/
<template>
    <div class="base-ref-dialog">
        <el-row>
            <el-col :span="24" class="search-input" v-if="searchInput">
                <el-input
                    placeholder="输入关键字进行过滤"
                    icon="search"
                    v-model="filterText"
                    v-on:keyup.enter.native="doSearch"
                    :on-icon-click="doSearch">
                </el-input>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" class="tree-data">
                <el-tree
                    ref="tree"
                    :data="treeData"
                    :props="defaultProps"
                    :show-checkbox="mulSelect"
                    :withParent="withParent"
                    :checkStrictly="checkStrictly"
                    :filter-node-method="filterNode"
                    :node-key="nodeKey"
                    :highlight-current="true"
                    :default-expanded-keys="defaultExpandedKeys"
                    :default-checked-keys="defaultCheckedKeys"
                    :current-node-key="currentSelectKey"
                    @node-click="handleNodeClick"
                    @check-change="handleCheckChange"
                    @current-change="handleCurrentChange">
                </el-tree>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default{
        components:{
        },
        props:{
            model:Object,
            filterMethod:Function,  //用来对展示结果集进行过滤
            defTreeData:Array,
            mulSelect:{
                type:Boolean,
                default:false
            },
            checkStrictly:{
                type:Boolean,
                default:false
            },
            withParent:{
                type:Boolean,
                default:false
            },
            value:[Object,Array],
            areaNameSearch: String
        },
        data:function(){

            return{
                treeData:[],
                searchInput:true,
                filterText:'',
                nodeKey:"id",
                defaultExpandedKeys:[],
                defaultCheckedKeys:[],
                currentSelect:{},
                currentSelectKey:null,
                multipleSelection:[],
                stopChange:false,   //tree 的setCheckedNodes和   handleCheckChange会反复触发，增加互斥处理
                defaultProps:{
                    children: 'children',
                    label: this.model.getRefFields().name
                },
            }
        },
        created:function(){

        },
        watch:{
            defTreeData:function(v){
                if(this.filterMethod){
                    this.treeData = this.filterTreeData(v, this.filterMethod);
                }else{
                    this.treeData = v;
                }
                if(v && v.length<5) this.setDefExpandNode(this.treeData);
            },
            value:{
                immediate: true,
                handler:function(v, oldv){
                    var tree=this.$refs.tree;
                    if(v){
                        if(this.mulSelect){
                            if(v == this.multipleSelection) return;
                            if(!this.checkStrictly && v) v = v.filter(d => !d.children || !d.children.length);
                            this.stopChange = true;
                            if(tree) {
                                tree.setCheckedNodes(v);
                            }else{
                                this.stopChange =false;
                                this.defaultCheckedKeys = v.map(d => d.id || d);
                                this.defaultExpandedKeys =this.defaultCheckedKeys;
                            }
                            this.stopChange =false;
                        }
                    }else{
                        this.multipleSelection = [];
                        this.currentSelect = null;
                        this.currentSelectKey = null;
                        if(tree) tree.setCheckedKeys([]);
                        if(tree) tree.store.currentNode = null;
                    }
                }
            }
        },
        methods:{
            setDefExpandNode:function(data){

                if(data && data.length>0){
                    // var nodekeys = [];
                    // nodekeys = defTreeData.map((d) => d.id);
                    this.defaultExpandedKeys = data.map((d) => d.id);;
                }
            },
            filterTreeData(nodes,filterMethod){

                var children = [];
                nodes.forEach(node => {
                    if(node.children && node.children.length){
                        var thischildren = this.filterTreeData(node.children,filterMethod);
                        node.children = thischildren;
                        if(thischildren && thischildren.length) children.push(node);
                    }else{
                        if(filterMethod(node)) children.push(node);
                    }
                });
                return children;
            },
            filterNode(value, data) {
                if (!value) return true;
                return data[this.defaultProps.label].indexOf(value) !== -1;
            },
            doSearch:function(){
                this.$refs.tree.filter(this.filterText);
            },
            handleDoSearch:function() {
              //执行选择地区过滤
              if ( this.areaNameSearch ) {
                  this.$refs.tree.filter(this.areaNameSearch);
              } else if (this.filterText) {
                  this.$refs.tree.filter(this.filterText);
                }
            },

            handleNodeClick:function(node){
                if(!this.mulSelect){
                    this.currentSelect = node;
                    this.$emit('input',node);
                }
            },
            handleCheckChange:function(node){

                if(this.mulSelect && !this.stopChange){
                    this.multipleSelection = this.$refs.tree.getCheckedNodes(false);
                    this.$emit('input',this.multipleSelection);
                }
            },
            handleCurrentChange:function(node){

            },
        }
    }
</script>
<style>
    .base-ref-dialog .el-row{
        margin-bottom: 10px;
    }

    .base-ref-dialog .el-tree{
        height: 400px;
        overflow: auto;
    }

    .base-ref-dialog .el-input__inner{
        width: 100% !important;
    }


</style>



// WEBPACK FOOTER //
// src/pub/components/baseRef/view/refTreePanel.vue